module.exports = __webpack_public_path__ + "static/media/hashtag-nft-15.cb91346f.jpg";